import { IconContent } from '@icons';

export const tubeFilled: IconContent = {
    md: '<path d="M16.743 3.308a1 1 0 0 0-1.414 0l-2.122 2.12a1 1 0 0 0-.061 1.348l5.078 5.078a1 1 0 0 0 1.347-.061l2.122-2.121a1 1 0 0 0 0-1.415l-4.95-4.95Zm.71 9.19-4.95-4.95-6.72 6.72a3.5 3.5 0 1 0 4.95 4.95l6.72-6.72Zm-9.898 1.42 4.95-4.949 1.41 1.41-4.95 4.95-1.41-1.41Z" />',
};
